"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RECHARGE_2021_01_TIMEZONE = exports.getBundlePricingDetails = exports.isNonDiaperBundleType = exports.isVariantLowStock = exports.isItemOOS = exports.showThirdPartyButtons = exports.hideThirdPartyButtons = exports.convertItemsToItemUpdateInputs = void 0;
var convertItemsToItemUpdateInputs = function (items) {
    return items.map(function (_a) {
        var _b = __read(_a, 2), variantId = _b[0], obj = _b[1];
        return ({
            properties: obj ? JSON.stringify(obj.properties) : '',
            quantity: obj && obj.quantity ? obj.quantity : 1,
            variantId: variantId,
        });
    });
};
exports.convertItemsToItemUpdateInputs = convertItemsToItemUpdateInputs;
// there is no great way to make the modal appear over top of the third-party widgets
// instead, we will manually hide and show them at the right time
var hideThirdPartyButtons = function () {
    $('#launcher').hide(); // zendesk
    $('#smile-ui-container').hide();
};
exports.hideThirdPartyButtons = hideThirdPartyButtons;
var showThirdPartyButtons = function () {
    $('#launcher').show(); // zendesk
    $('#smile-ui-container').show();
};
exports.showThirdPartyButtons = showThirdPartyButtons;
var isItemOOS = function (item) {
    var _a, _b, _c;
    if (!((_a = item.variant) === null || _a === void 0 ? void 0 : _a.inventory_management))
        return false;
    return !((_b = item.variant) === null || _b === void 0 ? void 0 : _b.inventory_quantity) || ((_c = item.variant) === null || _c === void 0 ? void 0 : _c.inventory_quantity) <= 0;
};
exports.isItemOOS = isItemOOS;
var isVariantLowStock = function (variant) {
    if (!variant || !variant.inventory_management)
        return false;
    return typeof variant.future_inventory_quantity === 'number' && variant.future_inventory_quantity <= 0;
};
exports.isVariantLowStock = isVariantLowStock;
var isNonDiaperBundleType = function (bundleType) {
    var nonBundleDiaperTypes = ['Vitamin', 'Fundamentals'];
    return nonBundleDiaperTypes.includes(bundleType);
};
exports.isNonDiaperBundleType = isNonDiaperBundleType;
var getBundlePricingDetails = function (groupedSubscription) {
    var futureCharge = groupedSubscription.futureCharge;
    // this should never happen
    if (!futureCharge) {
        return {
            totalPrice: 0,
            totalDiscounts: 0,
            subTotal: 0,
            taxes: 0,
        };
    }
    var totalPrice = Number(futureCharge.total_price);
    var totalDiscounts = Number(futureCharge.total_discounts);
    var subTotal = Number(futureCharge.total_line_items_price);
    var shippingTotal = futureCharge.shipping_lines.reduce(function (acc, curr) {
        return curr.price ? Number(curr.price) + acc : acc;
    }, 0);
    // taxes and shipping are lumped together in Recharge's charge object.
    // can't rely on total_tax because it's undefined for some cases
    var taxesAndShipping = totalPrice + totalDiscounts - subTotal;
    return {
        totalPrice: totalPrice,
        totalDiscounts: totalDiscounts,
        subTotal: subTotal,
        taxes: taxesAndShipping - shippingTotal,
        shipping: shippingTotal,
    };
};
exports.getBundlePricingDetails = getBundlePricingDetails;
/** Recharge's 2021-01 API unfortunately represents its timestamps in Eastern time rather than UTC. They've fixed this in their 2021-11 API version. */
exports.RECHARGE_2021_01_TIMEZONE = 'America/New_York';
